var React = require('react');

function CloseBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.29841 8.00011L13.2405 4.05796C13.5995 3.69891 13.5995 3.11856 13.2405 2.75952C12.8814 2.40047 12.3011 2.40047 11.9421 2.75952L8 6.70167L4.05793 2.75952C3.69889 2.40047 3.11855 2.40047 2.75951 2.75952C2.40047 3.11856 2.40047 3.69891 2.75951 4.05796L6.70159 8.00011L2.75951 11.9423C2.40047 12.3013 2.40047 12.8817 2.75951 13.2407C2.93857 13.4198 3.17365 13.5098 3.40872 13.5098C3.64379 13.5098 3.87887 13.4198 4.05793 13.2407L8 9.29856L11.9421 13.2407C12.1211 13.4198 12.3562 13.5098 12.5913 13.5098C12.8264 13.5098 13.0614 13.4198 13.2405 13.2407C13.5995 12.8817 13.5995 12.3013 13.2405 11.9423L9.29841 8.00011Z","fill":"#3A66E5"}));
}

CloseBlue.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = CloseBlue;

CloseBlue.default = CloseBlue;
